export function createEmitter() {
  const handlers = new Map();
  const emitter = {
    on(event, handler) {
      if (event && typeof event === "object") {
        Object.entries(event).forEach(([name, callback]) => emitter.on(name, callback));
        return;
      }

      if (!handlers.has(event)) handlers.set(event, new Set());
      handlers.get(event).add(handler);
    },
    off(event, handler) {
      if (!handlers.has(event)) return;
      if (handler) handlers.get(event).delete(handler);
      else handlers.delete(event);
    },
    emit(event, payload) {
      Array.from(handlers.get(event) || []).forEach(handler => handler(payload));
    },
  };

  return emitter;
}
